import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { resendConfirmation } from 'redux/ducks/Confirmation';

export const ConfirmationBanner = ({ user, authenticated, resendConfirmation }) => {
  const [resent, setResent] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (authenticated) {
      setResent(false);
      setIsDismissed(false);
    }
  }, [authenticated, user?.id]);

  if (!authenticated || user?.confirmedAt || isDismissed) {
    return null;
  }

  const onResendClick = e => {
    e.preventDefault();
    e.stopPropagation();

    resendConfirmation(user.email);
    setResent(true);

    setTimeout(() => {
      setIsDismissed(true);
    }, 4000);
  };

  return (
    <div className="confirmation-banner">
      <div className="message">
        <span className="message-text">
          {resent ? (
            <>Thank you, please check your email to verify.</>
          ) : (
            <>
              Action Required: Please verify your account by checking your email {user?.email}.{' '}
              <a href="#" onClick={onResendClick}>
                Resend Verification Email
              </a>
            </>
          )}
        </span>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.session.currentUser,
  authenticated: state.session.authenticated,
});

const mapDispatchToProps = dispatch => ({
  resendConfirmation: email => dispatch(resendConfirmation(email))
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationBanner);
